module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_3-3.a3849715.svg";